let swiper = require('./swiper').default

const BestPlaces = require('./best-places')

class Homepage
{
    constructor() {
        $helpers.initTooltips('#homepage')

        this.initSwiper()

        new BestPlaces

        if ($app.isMobile) {
            new BestPlaces('#new-homepage-top', true)
        }

        $('.editorial-collections .tabs__item').simpleTabs()
    }

    initSwiper() {
        let p = 1,
            rendered = []

        swiper('.swiper--home', {
            loop: true,
            spaceBetween: 0,
            breakpoints: null,
            autoplay: { delay: 11500 },
            pagination: { type: null },
            on: {
                reachEnd: s => {
                    if (p > 0) {
                        $.get($app.urlPrefix + '/page/index/homeslider', { p, rendered }, ({ slides, ids }) => {
                            if (slides.length) {
                                p++
                                rendered.push(...ids)
                                s.appendSlide(slides)
                            } else {
                                p = 0
                            }
                        });
                    }
                }
            }
        })

        let data = {
            slidesPerView: 'auto',
            breakpoints: {
                576: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 4
                }
            }
        }

        swiper('.popular-events .swiper', data)
        swiper('.popular-networks .swiper', data)
        swiper('.editorial-collections .swiper', data)
    }
}

module.exports = Homepage